// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

import { ImageCommonFragmentDoc } from './imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from './imageSize.fragment.generated';
export const CmsImageSizesFragmentDoc = `
    fragment cmsImageSizes on Image {
  ...imageCommon
  url
  width
  small: size(name: SMALL) {
    ...imageSize
  }
  small_x2: size(name: SMALL_X2) {
    ...imageSize
  }
  medium: size(name: MEDIUM) {
    ...imageSize
  }
  medium_x2: size(name: MEDIUM_X2) {
    ...imageSize
  }
  large: size(name: LARGE) {
    ...imageSize
  }
  cover: size(name: COVER) {
    ...imageSize
  }
  cover_x2: size(name: COVER_X2) {
    ...imageSize
  }
}
    `;